var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounTrash3523712(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,31.077h5.011c0,0.064-0.008,0.128-0.002,0.192l5,51.923C30.108,84.217,30.97,85,32,85h36   c1.03,0,1.892-0.783,1.991-1.808l5-51.923c0.006-0.064-0.002-0.128-0.002-0.192H80c1.657,0,3-1.343,3-3s-1.343-3-3-3H64.077V16   c0-1.657-1.343-3-3-3H38.923c-1.657,0-3,1.343-3,3v9.077H20c-1.657,0-3,1.343-3,3S18.343,31.077,20,31.077z M52,73   c0,1.104-0.896,2-2,2s-2-0.896-2-2V42.154c0-1.104,0.896-2,2-2s2,0.896,2,2V73z M60.13,40.158c1.102,0.071,1.938,1.023,1.866,2.125   l-2,30.846C59.927,74.188,59.048,75,58.002,75c-0.044,0-0.087-0.001-0.132-0.004c-1.102-0.071-1.938-1.023-1.866-2.125l2-30.846   C58.076,40.922,59.024,40.092,60.13,40.158z M41.923,19h16.154v6.077H41.923V19z M39.87,40.158   c1.124-0.066,2.054,0.764,2.126,1.866l2,30.846c0.071,1.102-0.765,2.054-1.866,2.125C42.085,74.999,42.042,75,41.998,75   c-1.046,0-1.925-0.813-1.994-1.871l-2-30.846C37.933,41.181,38.769,40.229,39.87,40.158z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounTrash3523712);
export default __webpack_public_path__ + "static/media/noun_Trash_3523712.257ff27554b3ef6d84e934e07859a2d9.svg";
export { ForwardRef as ReactComponent };